import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockData } from '../mockData';
import { ImageLightbox } from '../components/ImageLightbox';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../components/ui/carousel';

export const CustomDetail = () => {
  const { language } = useLanguage();
  const [selectedImages, setSelectedImages] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedTitle, setSelectedTitle] = useState(null);

  const customMachines = mockData.catalogItems.filter(item => item.category === 'Özel');

  const handleImageClick = (images, index, title) => {
    setSelectedImages(images);
    setSelectedIndex(index);
    setSelectedTitle(title);
  };

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {language === 'tr' ? 'Özel Makine İmalatı' : 'Custom Machine Manufacturing'}
          </h1>
          <p className="text-xl text-gray-600">
            {language === 'tr' 
              ? 'İhtiyaçlarınıza özel tasarlanmış endüstriyel makine ve sistemler'
              : 'Industrial machines and systems custom designed for your needs'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {customMachines.map((machine) => (
            <div
              key={machine.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-80">
                {machine.images.length > 1 ? (
                  <Carousel className="w-full h-full">
                    <CarouselContent>
                      {machine.images.map((image, idx) => (
                        <CarouselItem key={idx}>
                          <div 
                            className="h-80 cursor-pointer"
                            onClick={() => handleImageClick(machine.images, idx, machine.title)}
                          >
                            <img
                              src={image}
                              alt={`${machine.title} - ${idx + 1}`}
                              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                            />
                          </div>
                        </CarouselItem>
                      ))}
                    </CarouselContent>
                    <CarouselPrevious className="left-4" />
                    <CarouselNext className="right-4" />
                  </Carousel>
                ) : (
                  <div 
                    className="h-80 cursor-pointer overflow-hidden"
                    onClick={() => handleImageClick(machine.images, 0, machine.title)}
                  >
                    <img
                      src={machine.images[0]}
                      alt={machine.title}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                )}
              </div>

              <div className="p-6">
                <div className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full mb-3">
                  {language === 'tr' ? 'Özel İmalat' : 'Custom'}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{machine.title}</h3>
                <p className="text-gray-600 mb-4">{machine.description}</p>
                {machine.images.length > 1 && (
                  <p className="text-sm text-blue-600 font-semibold">
                    {language === 'tr' 
                      ? `${machine.images.length} fotoğraf - Kaydırarak görün` 
                      : `${machine.images.length} photos - Swipe to view`}
                  </p>
                )}
                <p className="mt-2 text-blue-700 font-semibold">
                  {language === 'tr' ? 'Fotoğrafı büyütmek için tıklayın' : 'Click to enlarge photo'}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Estetik Lightbox */}
      <ImageLightbox 
        images={selectedImages} 
        currentIndex={selectedIndex}
        title={selectedTitle}
        onClose={() => {
          setSelectedImages(null);
          setSelectedIndex(0);
          setSelectedTitle(null);
        }} 
      />
    </div>
  );
};
